// eslint-disable-next-line no-unused-vars
class Messages {
	constructor() {
		this.root = document.getElementById("messages");
		this.container = this.root.querySelector("[data-messages-container]");
		this.controllers = document.querySelectorAll('[aria-controls="messages"]');
		this.delayBeforeClear = 7000;

		this.handleControllers();
	}

	addMessage(messages, variant = "success") {
		this.root.classList.remove("-translate-y-full");
		if (variant === "error") {
			this.root.classList.add("!bg-alert");
		}

		messages.forEach((message) => {
			const node = document.createElement("li");
			node.innerHTML = message;
			this.container.appendChild(node);
		});

		setTimeout(this.clearMessages.bind(this), this.delayBeforeClear);
	}

	clearMessages() {
		this.root.classList.add("-translate-y-full");
		this.root.classList.remove("!bg-alert");
		this.root.addEventListener(
			"transitionend",
			() => {
				this.container.innerHTML = "";
			},
			{ once: true }
		);
	}

	handleControllers() {
		this.controllers.forEach((controller) => {
			controller.addEventListener("click", this.clearMessages.bind(this));
		});
	}
}
